import * as React from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@/components/ui/button';
import { aboutPage } from '@/content/engagement';

export function AboutPage() {
  React.useEffect(() => {
    const previous = document.title;
    document.title = aboutPage.documentTitle;
    return () => {
      document.title = previous;
    };
  }, []);

  return (
    <article className="px-4 py-14 sm:px-6 sm:py-16 lg:px-8">
      <div className="mx-auto w-full max-w-3xl">
        <p className="text-primary mb-3 text-xs font-medium tracking-[0.2em] uppercase">
          {aboutPage.eyebrow}
        </p>
        <h1 className="font-display text-foreground text-4xl font-semibold tracking-tight sm:text-5xl">
          {aboutPage.title}
        </h1>
        <p className="text-muted-foreground mt-5 text-base leading-relaxed sm:text-lg">
          {aboutPage.lead}
        </p>
        <div className="mt-6 space-y-4">
          {aboutPage.body.map((paragraph) => (
            <p key={paragraph} className="text-muted-foreground text-base leading-relaxed">
              {paragraph}
            </p>
          ))}
        </div>
        <div className="mt-10 flex flex-col gap-3 sm:flex-row">
          <Button asChild variant="cta">
            <Link to="/the-fund">About the Fund</Link>
          </Button>
          <Button asChild variant="outline">
            <Link to="/my-story">Read Mark’s story</Link>
          </Button>
        </div>
      </div>
    </article>
  );
}
